const mockData = {
  DigitalWall: {
    Config: {
      BranchDetail: {
        BranchDetailKey: 230000001,
        BranchName: "Branch1",
        LayoutName: "Landscape",
        Widget: ["UGC","Google Review", "Instagram"],
        QRCodeURL:
          "https://search.google.com/local/writereview?placeid=ChIJN8SQyvkGqTsRXxHQlswVCHY",
      },
    },
    Data: {
      UGC: [
        {
          UGCKey: 230000014,
          UGCURL:
            "https://digital--wall.s3.us-east-2.amazonaws.com/AAA/T Nagar/20231130171606065235.jpeg",
          FileName: "watchtarget1701324966.mp4",
          Description: "Nice",
          UGCCategoryName: "Retail",
        },
        {
          UGCKey: 230000015,
          UGCURL:
            "https://digital--wall.s3.us-east-2.amazonaws.com/AAA/T Nagar/20231130171612065235.jpeg",
          FileName: "watchtarget170.mp4",
          Description: "Good",
          UGCCategoryName: "Retail",
        },
      ],
      Review: [
        {
          ProfilePhotoUrl:
            "https://lh3.googleusercontent.com/a/ACg8ocKurYmghl_oESDNZ90QmxM0s2RXuc-GAe6PH4ia3QCU=s120-c-rp-mo-br100",
          DisplayName: "p suji",
          StarRating: "FOUR",
          CreateTime: "2023-11-01T12:19:34.306599Z",
          Comment:
            "Good teaching 🔥 best trainers very useful, I attended AI internship and really gathered lot of knowledge and information... Best place for beginners 🔥",
        },
        {
          ProfilePhotoUrl:
            "https://lh3.googleusercontent.com/a/ACg8ocI6re0RzqgpUSo0yk_xIF2FwGkW08n88SU_ge-snKs=s120-c-rp-mo-br100",
          DisplayName: "R. Yuvashri",
          StarRating: "FIVE",
          CreateTime: "2023-11-01T12:19:34.306599Z",
          Comment:
            "Good teaching 🔥 best trainers very useful, I attended AI internship and really gathered lot of knowledge and information... Best place for beginners 🔥",
        },
        {
          ProfilePhotoUrl:
            "https://lh3.googleusercontent.com/a-/ALV-UjUmj2_T5fHdBYwAxz1tTDUrN6_FS-SWnpRPWWf8q33FGqg=s120-c-rp-mo-br100",
          DisplayName: "Siva Prasad",
          StarRating: "FIVE",
          CreateTime: "2023-11-01T12:19:34.306599Z",
          Comment:
            "Good teaching 🔥 best trainers very useful, I attended AI internship and really gathered lot of knowledge and information... Best place for beginners 🔥",
        },
      ],
      Instagram: [
        {
          id: "18079668922419654",
          media_type: "IMAGE",
          comments_count: 0,
          like_count: 0,
          media_url:
            "https://scontent-ord5-1.cdninstagram.com/v/t51.29350-15/405548839_1077457910373373_1299234238140966524_n.webp?stp=dst-jpg&_nc_cat=111&ccb=1-7&_nc_sid=c4dd86&_nc_ohc=FKPXSkz6XF0AX_tKcMA&_nc_ht=scontent-ord5-1.cdninstagram.com&edm=AEoDcc0EAAAA&oh=00_AfDned0AeofQ33v0w3BHbKthH1Y06CKQQ2YKPfLDFRAckQ&oe=656E57EC",
          permalink: "https://www.instagram.com/p/C0TzzUjKg_g/",
          caption:
            "The same boiling water that softens the potato hardens the egg it's what you're made of .Not the circumstances 🤍🚀\n.\n.\n.\n.\n.\n.\n\n#مدلینگ #ترند #عکاسی_پرتره #مدلینگ_عکاسی #لباس_مجلسی #لباس #آزادی #تهران  #ایران #مد#چشم_رنگی #چالش_جدید #زندگی  #بلاگر_ایرانی #بلاگر #خدا #فیتنس #پاییز  #موفقیت #هدف#ادیت #مانکن#modeling #model#live #lifestyle # healthy lifestyle #love #fashion  #gym #edit",
          timestamp: "2023-12-01T11:56:11+0000",
        },
        {
          id: "17906456612864335",
          media_type: "VIDEO",
          comments_count: 0,
          like_count: 0,
          media_url:
            "https://scontent-ord5-1.cdninstagram.com/o1/v/t16/f1/m82/1B4B23A022FFF97EDE384A98202D199D_video_dashinit.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLmNsaXBzLnVua25vd24tQzMuNzIwLmRhc2hfYmFzZWxpbmVfMV92MSJ9&_nc_ht=scontent-ord5-1.cdninstagram.com&_nc_cat=100&vs=3647195458882943_817279603&_nc_vs=HBksFQIYT2lnX3hwdl9yZWVsc19wZXJtYW5lbnRfcHJvZC8xQjRCMjNBMDIyRkZGOTdFREUzODRBOTgyMDJEMTk5RF92aWRlb19kYXNoaW5pdC5tcDQVAALIAQAVAhg6cGFzc3Rocm91Z2hfZXZlcnN0b3JlL0dIOHpQUmlzRlBBdnpNd0NBTDNOcjRGWEU1UWRicV9FQUFBRhUCAsgBACgAGAAbAYgHdXNlX29pbAExFQAAJvK6wJKRvd0%2FFQIoAkMzLBdARYlYEGJN0xgSZGFzaF9iYXNlbGluZV8xX3YxEQB1AAA%3D&ccb=9-4&oh=00_AfDumsd0F-zJPfN1spZCMiwKYG8DHf9DgQAys9MXSvcSsQ&oe=656BC2F7&_nc_sid=1d576d&_nc_rid=54585da940",
          permalink: "https://www.instagram.com/reel/C0TzgsyvYfG/",
          caption:
            "Made it to the top! Saw loads of Gorgeous temples in Cambodia🏯\n\n#Beach #sunset #thiland #traveling #sun #sand #beaut #happy #live #life #backpacking #vibes #family #bff #view #stars #fullmoon #rocks #bevvy #asia #food #goodtime #tattoo #plants #exotic #ferns #coconut #fireworks #Cambodia #Festival",
          timestamp: "2023-12-01T11:56:10+0000",
        },
        {
          id: "18083058478372773",
          media_type: "CAROUSEL_ALBUM",
          comments_count: 0,
          like_count: 0,
          permalink: "https://www.instagram.com/p/C0TzzFLrLAh/",
          caption:
            "Terima kasih November untuk segala kenangan. Aku tutup dengan penuh rasa syukur dan gembira.\n\nUntuk Disember, semoga akan ada banyak perkara baik yang mahu mendekat. Yang terpenting lebih bahagia dari sebelumnya!\n\n#magnetjanaincome #bussiness#reels #feedback #post#reelsinstagram #live #trend #uitm #utm #bmw #mercedes #golfr #hijab #muslimah #surirumah",
          timestamp: "2023-12-01T11:56:09+0000",
        },
      ],
    },
  },
};
export default mockData;
